import React, { JSX } from "react";
import { valueOrDashes } from "@app/shared/utility/valueOrDashes";
import { CareJourneyScoresEpisode, ServicingProviderDetail } from "../results/servicing-provider/servicingProviderDetail";
import { Waffles } from "@app/shared/waffles/Waffles";
import { TextAlignment, wafflesKeyColumnName, WafflesThemes } from "@app/shared/waffles/exports";


interface CareJourneyScoresProps {
  record: ServicingProviderDetail;
}

export interface CareJourneyConditionTableData {
  episodeName: string | JSX.Element;
  numberOfEpisodes: string | JSX.Element;
  costScore: string | JSX.Element;
  qualityScore: string | JSX.Element;
  [wafflesKeyColumnName]: string;
}

const carejourneyColumnConfig = {
  /* oxlint-disable sort-keys */
  episodeName: {
    alignment: TextAlignment.Left,
    displayText: "Episode Name",
    noSort: true,
    testId: "pci-flyout-episode-name",
  },
  numberOfEpisodes: {
    alignment: TextAlignment.Left,
    displayText: "Number of Episodes",
    noSort: true,
    testId: "pci-flyout-number-of-episodes",
  },
  costScore: {
    alignment: TextAlignment.Left,
    displayText: "Cost Score",
    noSort: true,
    testId: "pci-flyout-cost-score",
  },
  qualityScore: {
    alignment: TextAlignment.Left,
    displayText: "Quality Score",
    noSort: true,
    testId: "pci-flyout-quality-score",
  }
  /* oxlint-enable sort-keys */
};

function mapEpisodesToTableData(episodes: CareJourneyScoresEpisode[]): CareJourneyConditionTableData[] {
  return episodes.map(ep => ({
    /* oxlint-disable sort-keys */
    episodeName: <>{valueOrDashes(ep.name)}</>,
    numberOfEpisodes: <>{valueOrDashes(ep.count)}</>,
    costScore: <>{valueOrDashes(ep.costScore)}/5</>,
    qualityScore: <>{valueOrDashes(ep.qualityScore)}/5</>,
    [wafflesKeyColumnName]: ep.name
    /* oxlint-enable sort-keys */
  }));
}

export const CareJourneyScores: React.FC<CareJourneyScoresProps> = ({ record }) => {
  const episodes: CareJourneyScoresEpisode[] = record?.careJourneyScoresTopEpisodes || [];
  const tableData: CareJourneyConditionTableData[] = mapEpisodesToTableData(episodes);

  return (
    <div>
      <div>
        <div className="data-box">
          <span className="data-box-header">Cost Score: </span>
          <span className="data-box-content">{valueOrDashes(record?.careJourneyScoresCostScore)}/5</span>
        </div>
      </div>
      <div>
        <div className="data-box">
          <span className="data-box-header">Quality Score: </span>
          <span className="data-box-content">{valueOrDashes(record?.careJourneyScoresQualityScore)}/5</span>
        </div>
      </div>
      <h6>Episode Cost and Quality</h6>
      <Waffles<CareJourneyConditionTableData>
        columns={carejourneyColumnConfig}
        data={tableData}
        disableStickyHeader={true}
        fullWidth={true}
        hideTableHead={false}
        keyColumns={["type"]}
        testId={`servicing-provider-profile__carejourney-location-table`}
        theme={WafflesThemes.Simple}
      />
    </div>
  );
}

export default CareJourneyScores;
